import { Path, Svg } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const Itinerary = withDefaultIconProps({ color: '#000000', height: 16, width: 16 }, ({ color, ...rest }) => (
  <Svg {...rest} viewBox="0 0 16 16" fill="none">
    <Path
      d="M1.732 6.233a2.5 2.5 0 000 3.536l4.501 4.5a2.5 2.5 0 003.536 0l4.5-4.5a2.5 2.5 0 000-3.536l-4.5-4.5a2.5 2.5 0 00-3.536 0l-4.501 4.5zm.707 2.829a1.5 1.5 0 010-2.122l4.501-4.5a1.5 1.5 0 012.122 0l4.5 4.5a1.5 1.5 0 010 2.122l-4.5 4.5a1.502 1.502 0 01-2.122 0l-4.501-4.5zm6.414-4.416a.5.5 0 00-.707.708L8.793 6H7.5A1.5 1.5 0 006 7.5V10a.5.5 0 101 0V7.5a.5.5 0 01.5-.5h1.293l-.647.646a.5.5 0 10.707.708l1.5-1.5a.5.5 0 000-.708l-1.5-1.5z"
      fill={color}
    />
  </Svg>
));
